import { createSelector } from '@reduxjs/toolkit';

import type { AppState } from 'redux-store';

import type { ProductsTypeV3 } from 'domains/products/products.types';

export const getOldProducts = (state: AppState): AppState['products'] =>
  state.products;
export const getProductsReducerSelector = (
  state: AppState,
): AppState['productsV3'] => state.productsV3;

export const getProductSelector = createSelector(
  getProductsReducerSelector,
  (_: AppState['productsV3'], id: number) => id,
  (products: AppState['productsV3'], id: number) => products.items[id] || null,
);

export const getProductsSelector = createSelector(
  getProductsReducerSelector,
  (products: AppState['productsV3']) => {
    const list = Object.values(products.items);

    return list.sort((a, b) => a.order - b.order);
  },
);

export const getProductsSaleSelector = createSelector(
  getProductsReducerSelector,
  (products: AppState['productsV3']) => {
    if (!products.items) {
      return [];
    }
    let list = Object.values(products.items);
    list = list.map((item: ProductsTypeV3) => {
      if (item.interval === 'lifetime') {
        const lifetime_new_price = 499;
        const price = lifetime_new_price;
        let discount = item?.discount;
        if (item.discount_price) {
          discount = Math.trunc((1 - item.discount_price / lifetime_new_price) * 100);
        }
        return {
          ...item,
          price: price,
          discount: discount,
        }
      }
      return item;
    });

    return list.sort((a, b) => a.order - b.order);
  },
);

export const getIsLoadingSelector = createSelector(
  getProductsReducerSelector,
  ({ isLoading }) => isLoading,
);

export const getPaidProductsSelector = createSelector(
  getProductsReducerSelector,
  (products: AppState['productsV3']) =>
    Object.values(products.items).find(
      ({ is_paid, is_current }) => is_paid && is_current,
    ),
);

export const getNotPaidProductsSelector = createSelector(
  getProductsReducerSelector,
  (products: AppState['productsV3']) =>
    Object.values(products.items).filter(({ is_paid }) => !is_paid),
);

export const getFirstProductsSelector = createSelector(
  getNotPaidProductsSelector,
  products => products[0],
);

export const getCurrentProductSelector = createSelector(
  getFirstProductsSelector,
  (notPaidProduct): ReturnType<typeof getFirstProductsSelector> | null =>
    notPaidProduct || null,
);

export const getDiscountSelector = createSelector(
  getNotPaidProductsSelector,
  products => {
    return products.length ? products[0].discount : null;
  },
);
